import React from 'react'
import { useTheme } from '@mui/material/styles'
import Button from 'components/Button'
import InfoMessage from 'components/InfoMessage'
import ResponsiveDialog from 'components/ResponsiveDialog'
import TextArea from 'components/TextArea'
import { DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import ReactMarkdown from 'react-markdown'
import useStyles from './styles'

export interface ITextAnswerDialogProps {
  open: boolean
  disabled: boolean
  onClose: () => void
  onCancel: () => void
  onSubmit: () => void
  title: string
  textualAnswer: string
  onTextualAnswerChange: (textualAnswer: string) => void
}

function TextAnswerDialog(props: ITextAnswerDialogProps) {
  const { open, onClose, onCancel, onTextualAnswerChange, onSubmit, title, textualAnswer, disabled } = props
  const theme = useTheme()
  const { classes } = useStyles()

  if (!open) {
    return null
  }

  return (
    <ResponsiveDialog open fullWidth onClose={onClose}>
      <DialogTitle>
        {title}
      </DialogTitle>

      <DialogContent>
        <div style={{ padding: theme.spacing(1, 0) }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextArea
                name="textual_answer"
                label="Your text answer"
                placeholder={title}
                value={textualAnswer || ''}
                onChange={e => onTextualAnswerChange(e.target.value)}
                maxLength={1500}
              />
            </Grid>

            {textualAnswer && (
              <div className={classes.previewCardContent}>
                Markdown Preview:

                <ReactMarkdown
                  source={textualAnswer}
                />
              </div>
            )}

            <Grid item xs={12}>
              <InfoMessage>
                You can also provide a video answer to this question via camera or video file upload.
                Video answers are often more convincing and preferred over text-based answers.
              </InfoMessage>
            </Grid>
          </Grid>
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel}>
          Cancel
        </Button>

        <Button color="primary" onClick={onSubmit} disabled={disabled} data-cy="submit-text-answer">
          Answer
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}

export default React.memo(TextAnswerDialog)
